export class PropinaModel {
    idpropina: number;
    descripcion: string;
    value: number;
    checked: boolean;
}
